export default __webpack_public_path__ + "static/media/sideMenu_live.2bc928f1.svg";